import React from "react";

function LeftSider() {
  const links = [
    {
      label: "Email",
      abbr: "EM",
      href: "mailto:junaidhussain798@outlook.com",
    },
    {
      label: "LinkedIn",
      abbr: "LI",
      href: "https://linkedin.com/in/junaid798",
    },
    {
      label: "GitHub",
      abbr: "GH",
      href: "https://github.com/Mohammed-Junaid-Hussain",
    },
    {
      label: "LeetCode",
      abbr: "LC",
      href: "https://leetcode.com/u/Juniad-Hussain",
    },
    {
      label: "Resume",
      abbr: "CV",
      href: "/Final_Resume_wp.pdf",
    },
  ];

  return (
    <>
      {/* Desktop Version - Left Sidebar */}
      <div className="fixed left-6 bottom-0 hidden lg:flex z-50">
        <div className="flex flex-col items-center gap-4">
          {/* Social Links */}
          {links.map((link, idx) => (
            <a
              key={link.label}
              href={link.href || "#"}
              target={link.href.startsWith("mailto") ? "_self" : "_blank"}
              rel="noopener noreferrer"
              className="group relative"
              style={{
                animation: `fadeInUp 0.6s ease-out ${idx * 0.1}s both`,
              }}
            >
              {/* Icon Circle - Enhanced visibility */}
              <div
                className="w-10 h-10 flex items-center justify-center rounded-full 
                            bg-white/[0.05] border border-white/[0.15] shadow-lg shadow-white/5
                            group-hover:bg-white/[0.1] group-hover:border-white/[0.25]
                            transition-all duration-500"
              >
                <span
                  className="text-white/50 group-hover:text-white/80 text-[10px] uppercase 
                               tracking-wider font-medium transition-colors duration-500"
                >
                  {link.abbr}
                </span>
              </div>

              {/* Tooltip */}
              <div
                className="absolute left-full ml-4 top-1/2 -translate-y-1/2 
                          opacity-0 group-hover:opacity-100 pointer-events-none
                          transition-all duration-300 group-hover:translate-x-1"
              >
                <div
                  className="px-3 py-1.5 bg-white/[0.08] border border-white/[0.12] 
                            rounded-lg backdrop-blur-xl whitespace-nowrap"
                >
                  <span className="text-white/70 text-xs font-light">
                    {link.label}
                  </span>
                </div>
                {/* Arrow */}
                <div className="absolute right-full top-1/2 -translate-y-1/2 mr-[-1px]">
                  <div
                    className="w-2 h-2 bg-white/[0.08] border-l border-t border-white/[0.12] 
                              rotate-[-45deg] backdrop-blur-xl"
                  ></div>
                </div>
              </div>
            </a>
          ))}

          {/* Vertical Line */}
          <div className="w-[1px] h-24 bg-gradient-to-t from-white/20 to-transparent mt-2"></div>
        </div>

        <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      </div>
    </>
  );
}

export default LeftSider;
